import { $themeBreakpoints } from "@themeConfig";

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    chatQuery: {},
    chatDraft: {},
    callQuery: {},
    serviceSystemQuery: {},
    departmentServiceSystemQuery: {},
    conversationSummary: {},
    pushedToRag: {},
  },
  getters: {
    currentBreakPoint: (state) => {
      const { windowWidth } = state;
      if (windowWidth >= $themeBreakpoints.xl) return "xl";
      if (windowWidth >= $themeBreakpoints.lg) return "lg";
      if (windowWidth >= $themeBreakpoints.md) return "md";
      if (windowWidth >= $themeBreakpoints.sm) return "sm";
      return "xs";
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val;
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay =
        val !== undefined ? val : !state.shallShowOverlay;
    },
    UPDATE_CHAT_QUERY(state, val) {
      state.chatQuery = val;
    },
    UPDATE_CHAT_DRAFT(state, { key, value }) {
      state.chatDraft[key] = value;
    },
    UPDATE_CALL_QUERY(state, val) {
      state.callQuery = val;
    },
    UPDATE_SERVICE_SYSTEM_QUERY(state, val) {
      state.serviceSystemQuery = val;
    },
    UPDATE_DEPARTMENT_SERVICE_SYSTEM_QUERY(state, val) {
      state.departmentServiceSystemQuery = val;
    },
    UPDATE_CONVERSATION_SUMMARY(state, val) {
      state.conversationSummary = val;
    },
    UPDATE_PUSHED_TO_RAG(state, val) {
      state.pushedToRag = val;
    },
  },
  actions: {},
};
